import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchHospitalList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/hospitals", baseUrl);

  if (params.name) {
    endpointUrl.searchParams.append("name", params.name);
  }

  if (params.address) {
    endpointUrl.searchParams.append("address", params.address);
  }

  if (params.contact) {
    endpointUrl.searchParams.append("contact", params.contact);
  }

  if (params.email) {
    endpointUrl.searchParams.append("email", params.email);
  }

  if (params.orderBy) {
    endpointUrl.searchParams.append("orderBy", params.orderBy);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useHospitalList(params = {}) {
  return usePaginationQuery(
    [
      "hospitals",
      params.name,
      params.address,
      params.contact,
      params.email,
      params.orderBy,
    ],
    (paginationState) => fetchHospitalList({ ...params, ...paginationState })
  );
}

export function useUpdateHospital(id) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/hospitals/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["hospital-detail"]);
          setTimeout(() => {
            navigate(`/hospital/${id}/detail`);
          }, 1500);
        }
      },
      onError: () => {
        console.error("Something when wrong");
      },
    }
  );
}

export async function fetchHospitalDownload() {
  const { data } = await http(`/admin/hospitals-download`, {
    responseType: "blob",
  });

  return data;
}

export function useHospitalDownload() {
  const { data, ...raResult } = useQuery(["hospital-download"], () =>
    fetchHospitalDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
